// extracted by mini-css-extract-plugin
module.exports = {"fixed":"FixedWeb_fixed__32sCp","round":"FixedWeb_round__3WaA-","text":"FixedWeb_text__1Igw_"};